<template>
  <lf-tag
    v-if="value"
    v-tooltip="$t('COMMON.CLICK_TO_COPY')"
    class="cursor-pointer border border-divider bg-white"
    @click.stop.prevent="copyToClipboard(modelValue)"
  >
    <div class="line-clamp-1 min-w-max">
      {{ value }}
    </div>
  </lf-tag>
</template>

<script setup lang="ts" generic="T extends { id: string | number }">
import { useClipboardWithMessage } from "@/hooks/clipboard";

import LfTag from "@/components/ui/text/LfTag.vue";

import type { PropType } from "vue";

defineProps({
  // use the value from the formatter to show short ID if desired
  // use the modelValue to copy the full ID
  value: {
    type: [String, Number],
    default: "",
  },
  modelValue: {
    type: [String, Number],
    default: "",
  },
  model: {
    type: Object as PropType<T>,
    required: true,
  },
});

const copyToClipboard = useClipboardWithMessage();
</script>
